
import { defineComponent } from "vue";
import AccountSettings from "@/components/account/AccountSettings.vue";

export default defineComponent({
  name: "AccountView",
  components: { AccountSettings }
});
